import { uniqueId } from 'lodash'
import { Dispatch } from 'redux'

export const CLEAR_ACCOUNT_SEARCH = uniqueId('CLEAR_ACCOUNT_SEARCH')

export const clearAccountSearch = (dispatch: Dispatch) => dispatch({ type: CLEAR_ACCOUNT_SEARCH })
